/* eslint-disable eqeqeq */
import React from "react";
import { useSelector } from "react-redux";
import { LOCATION_TYPE } from "../../Location/Data";

const useLocationStops = (data) => {
  const { allLocations } = useSelector((state) => state.locations);

  const { stops } = useSelector((state) => state.trips);

  const validLocations = allLocations.filter(
    (l) => l.type !== LOCATION_TYPE.HUB_STATION,
  );

  const origin = stops[0];

  const selectedStops = stops
    ?.filter((s) => s.id !== Number(s.locationId))
    .map((s) => Number(s.locationId));

  const currentLocationType = data?.locationType ?? 0;

  // if origin is selected
  if (+origin.locationId !== 1) {
    // filter all locations based on hubId (hub Id will be equal to origin location id)
    let locations = validLocations.filter(
      (loc) => loc?.hubId === origin.locationId,
    );

    // if location type is selected (type = collection, delivery, aggregation)
    if (currentLocationType !== 0) {
      locations = locations.filter((l) => l.type === currentLocationType);
    }

    // if stops are already added, do not show those stops again
    if (selectedStops?.length) {
      locations = locations.filter((l) => !selectedStops.includes(l.id));
    }

    locations = locations.map((item) => ({
      key: item.id,
      value: item.name,
      label: (
        <div className="flex items-center px-2 py-2 gap-x-3">
          <p className="text-xs font-semibold text-black capitalize font-aileron">
            {item.name}
          </p>
        </div>
      ),
    }));

    return locations;
  }

  // if origin is not yet selected, return all the locations
  const locations = validLocations.map((item) => ({
    key: item.id,
    value: item.name,
    label: (
      <div className="flex items-center px-2 py-2 gap-x-3">
        <p className="text-xs font-semibold text-black capitalize font-aileron">
          {item.name}
        </p>
      </div>
    ),
  }));

  return locations;
};

export const getLocationStops = ({ stops, allLocations, id }) => {
  const validLocations = allLocations.filter(
    (l) => l.type !== LOCATION_TYPE.HUB_STATION,
  );

  const origin = stops[0];

  const selectedLocationIds = stops
    .filter((s) => s.location !== "Stop" && s.id !== id)
    .map((s) => Number(s.locationId));

  const currentItem = stops?.find((s) => s.id === id);

  // if origin is selected
  if (+origin.locationId !== 1) {
    // filter all locations based on hubId (hub Id will be equal to origin's location id)
    let locations = validLocations.filter(
      (loc) => loc.hubId == origin.locationId,
    );

    // if location type is selected (type = collection, delivery, aggregation)
    locations = locations.filter((l) => l.type == currentItem?.locationType);

    // if stops are already added, do not show those stops again
    if (selectedLocationIds?.length) {
      locations = locations.filter((l) => !selectedLocationIds.includes(l.id));
    }

    locations = locations.map((item) => ({
      key: item.id,
      value: item.name,
      label: (
        <div className="flex items-center px-2 py-2 gap-x-3">
          <p className="text-xs font-semibold text-black capitalize font-aileron">
            {item.name}
          </p>
        </div>
      ),
    }));

    return locations.sort((a, b) => a?.value?.localeCompare(b?.value));
  }

  // if origin is not yet selected, return all the locations
  const locations = validLocations.map((item) => ({
    key: item.id,
    value: item.name,
    label: (
      <div className="flex items-center px-2 py-2 gap-x-3">
        <p className="text-xs font-semibold text-black capitalize font-aileron">
          {item.name}
        </p>
      </div>
    ),
  }));

  return locations.sort((a, b) => a?.value?.localeCompare(b?.value));
};

export default useLocationStops;
